import React from 'react';

import {
	Alert,
	Card,
	CardBody,
	CardHeader,
	Col,
	Row
} from 'reactstrap';
import {productService} from '../../services/product.service';
import ProductsList from 'components/Products/ProductsList';
import ProductsNav from 'components/Products/ProductsNav';

class Inventory extends React.Component {
	constructor(props) {
		super(props);
		let forecastOptions =
				['Install date set only',
				 'Install date set + won deals',
				 'Future estimates'];
		let currentWeek = new Date();
		// Set currentWeek to the most recent Sunday at 12am.
		currentWeek.setDate(currentWeek.getDate() - currentWeek.getDay());
		currentWeek.setHours(0);
		let plus1Week = new Date(currentWeek);
		plus1Week.setDate(currentWeek.getDate() + 7);
		let plus2Weeks = new Date(currentWeek);
		plus2Weeks.setDate(currentWeek.getDate() + 14);
		let plus3Weeks = new Date(currentWeek);
		plus3Weeks.setDate(currentWeek.getDate() + 21);
		this.state = {
			loading: true,
			allProducts: [],
			categories: [],
			productList: [],
			pipelines: [],
			pipelineFilters: [],
			salesArea: [],
			salesAreaCurrent: 0,
			installDataDuration: 0,
			forecastEnd: 0,
			growthPercentage: 20,
			forecastCurrent: forecastOptions[0],
			forecastOptions: forecastOptions,
			currentWeek: currentWeek,
			plus1Week: plus1Week,
			plus2Weeks: plus2Weeks,
			plus3Weeks: plus3Weeks
		};
	}

	componentDidMount() {
		productService.getProductsRequired().then(response => {
			this.setState({
				allProducts: response.Data.products,
				categories: this.uniqueCategories(response.Data.products),
				salesArea: response.Data.salesArea,
				pipelines: response.Data.pipelines});
			if (response.Data.salesArea[0]) {
				this.setState({salesAreaCurrent: response.Data.salesArea[0].ID});
				this.updateProductList(response.Data.salesArea[0].ID);
			}
		});
	}

	updateProductList = (salesArea, filters) => {
		let {pipelineFilters} = this.state;
		if (filters) {
			pipelineFilters = filters;
		}
		let productList = {};
		this.state.allProducts.forEach(product => {
			if (salesArea && product.SalesArea !== salesArea) {
				return;
			}
			if (pipelineFilters.find(p => p.ExternalID === product.PipelineID)) {
				return;
			}

			// Store original quantity so it doesn't get overwritten by grouping,
			// and otherwise reset quantity to original for the new calculation.
			if (product.originalQuantity) {
				product.Quantity = product.originalQuantity;
			}
			else {
				product.originalQuantity = product.Quantity;
			}
			this.updateQuantity(productList, product, 1);
		});
		this.setState({
			loading: false,
			salesAreaCurrent: salesArea,
			productList: Object.values(productList)});
	}

	updateProductForecast = (end, growth, filters) => {
		let {salesAreaCurrent,
				 installDataDuration,
				 growthPercentage,
				 pipelineFilters} = this.state;
		if (filters) {
			pipelineFilters = filters;
		}
		if (isFinite(growth)) {
			growthPercentage = growth;
		}
		let today = new Date();
		let forecastDuration = end - today;
		let forecastFactor = 1 + growthPercentage / 100;
		if (installDataDuration > 0) {
			forecastFactor *= forecastDuration / installDataDuration;
		}
		let productList = {};
		this.state.allProducts.forEach(product => {
			if (salesAreaCurrent && product.SalesArea !== salesAreaCurrent) {
				return;
			}
			if (pipelineFilters.find(p => p.ExternalID === product.PipelineID)) {
				return;
			}

			if (product.originalQuantity) {
				product.Quantity = product.originalQuantity;
			}
			else {
				product.originalQuantity = product.Quantity;
			}
			this.updateQuantity(productList, product, forecastFactor);
		});
		this.setState({
			loading: false,
			productList: Object.values(productList)});
	}

	updateAllProducts = (date, forecast) => {
		this.setState({
			loading: true,
			productList: []});
		let {forecastOptions} = this.state;
		if (forecast === forecastOptions[0]) {
			productService.getProductsRequired().then(response => {
				this.setState({
					allProducts: response.Data.products,
					categories: this.uniqueCategories(response.Data.products),
					forecastCurrent: forecast});
				this.updateProductList(this.state.salesAreaCurrent);
			});
		}
		else if (forecast === forecastOptions[1]) {
			productService.getProductsNeeded(date).then(response => {
				this.setState({
					allProducts: response.Data.products,
					categories: this.uniqueCategories(response.Data.products),
					forecastCurrent: forecast});
				this.updateProductList(this.state.salesAreaCurrent);
			});
		}
		else if (forecast === forecastOptions[2]) {
			if (date) {
				// The end date is provided here to calculate forecasting, but it
				// doesn't change the database query so don't need to go back to the
				// server. (The data is fetched the first time the forecast option is
				// selected, which calls this function without a date set.)
				this.setState({forecastEnd: date});
				this.updateProductForecast(date);
				return;
			}

			productService.getProductsForecast().then(response => {
				let start = '';
				let end = '';
				let productList = {};
				response.Data.products.forEach(product => {
					if (start === '' || product.InstallDate < start) {
						start = product.InstallDate;
					}
					if (end === '' || product.InstallDate > end) {
						end = product.InstallDate;
					}
					this.updateQuantity(productList, product, 1);
				});
				let startDate = new Date(start);
				let endDate = new Date(end);
				let installDataDuration = endDate - startDate;
				let forecastEnd = new Date().getTime() + installDataDuration;
				this.setState({
					allProducts: Object.values(productList),
					categories: this.uniqueCategories(Object.values(productList)),
					installDataDuration: installDataDuration,
					forecastEnd: forecastEnd,
					forecastCurrent: forecast});
				this.updateProductForecast(forecastEnd);
			});
		}
	}

	uniqueCategories = (products) => {
		let categories = {};
		products.map(p => {
			if (!categories[p.Category]) {
				categories[p.Category] = true;
			}
		});
		return Object.keys(categories).sort();
	}

	updateQuantity = (productList, product, forecastFactor) => {
		let {plus1Week, plus2Weeks, plus3Weeks} = this.state;
		let productDate = new Date(product.Date);

		if (productList[product.ID]) {
			if (productDate < plus1Week) {
				productList[product.ID].CurrentWeekQuantity += product.Quantity;
				productList[product.ID].CurrentWeekDays[productDate.getDay()] += product.Quantity
			}
			else if (productDate < plus2Weeks) {
				productList[product.ID].Plus1WeekQuantity += product.Quantity;
				productList[product.ID].Plus1WeekDays[productDate.getDay()] += product.Quantity
			}
			else if (productDate < plus3Weeks) {
				productList[product.ID].Plus2WeeksQuantity += product.Quantity;
			}
			productList[product.ID].Quantity += product.Quantity;
		}
		else {
			productList[product.ID] = product;
			productList[product.ID].CurrentWeekQuantity = 0;
			productList[product.ID].Plus1WeekQuantity = 0;
			productList[product.ID].Plus2WeeksQuantity = 0;
			productList[product.ID].CurrentWeekDays = [0, 0, 0, 0, 0, 0, 0];
			productList[product.ID].Plus1WeekDays = [0, 0, 0, 0, 0, 0, 0];
			if (productDate < plus1Week) {
				productList[product.ID].CurrentWeekQuantity = product.Quantity;
				productList[product.ID].CurrentWeekDays[productDate.getDay()] = product.Quantity
			}
			else if (productDate < plus2Weeks) {
				productList[product.ID].Plus1WeekQuantity = product.Quantity;
				productList[product.ID].Plus1WeekDays[productDate.getDay()] = product.Quantity
			}
			else if (productDate < plus3Weeks) {
				productList[product.ID].Plus2WeeksQuantity = product.Quantity;
			}
		}
		productList[product.ID].Quantity =
			Math.ceil(productList[product.ID].Quantity * forecastFactor);
		productList[product.ID].CurrentWeekQuantity =
			Math.ceil(productList[product.ID].CurrentWeekQuantity * forecastFactor);
		productList[product.ID].Plus1WeekQuantity =
			Math.ceil(productList[product.ID].Plus1WeekQuantity * forecastFactor);
		productList[product.ID].Plus2WeeksQuantity =
			Math.ceil(productList[product.ID].Plus2WeeksQuantity * forecastFactor);
	}

	updateGrowthPercentage = (growth) => {
		growth = parseInt(growth, 10);
		if (isNaN(growth) || growth < 0) {
			growth = 0;
		}
		this.setState({growthPercentage: growth});
		this.updateProductForecast(this.state.forecastEnd, growth);
	}

	updateFilters = (filter) => {
		let {pipelineFilters,
				 salesAreaCurrent,
				 forecastCurrent,
				 forecastEnd,
				 growthPercentage,
				 forecastOptions} = this.state;
		if (!pipelineFilters.find(pipeline => pipeline.ID === filter.ID)) {
			pipelineFilters.push(filter);
			this.setState({pipelineFilters: pipelineFilters});
			if (forecastCurrent === forecastOptions[0] ||
					forecastCurrent === forecastOptions[1]) {
				this.updateProductList(salesAreaCurrent, pipelineFilters);
			}
			else {
				this.updateProductForecast(forecastEnd, growthPercentage, pipelineFilters);
			}
		}
	}

	removeFilter = (filter) => {
		let {pipelineFilters,
				 salesAreaCurrent,
				 forecastCurrent,
				 forecastEnd,
				 growthPercentage,
				 forecastOptions} = this.state;
		if (pipelineFilters.find(pipeline => pipeline.ID === filter.ID)) {
			pipelineFilters = pipelineFilters.filter(pipeline =>
			                                         pipeline.ID != filter.ID);
			this.setState({pipelineFilters: pipelineFilters});
			if (forecastCurrent === forecastOptions[0] ||
					forecastCurrent === forecastOptions[1]) {
				this.updateProductList(salesAreaCurrent, pipelineFilters);
			}
			else {
				this.updateProductForecast(forecastEnd, growthPercentage, pipelineFilters);
			}
		}
	}

	render() {
		const {loading,
					 categories,
					 productList,
					 salesArea,
					 forecastOptions,
					 forecastEnd,
					 growthPercentage,
					 pipelines,
					 pipelineFilters,
					 currentWeek,
					 plus1Week,
					 plus2Weeks,
					 plus3Weeks,
					 forecastCurrent} = this.state;
		return (
			<div className="content">
				<Alert color="primary" isOpen={loading}>
					Loading inventory data...</Alert>
				<Row>
					<Col>
						<Card>
							<CardHeader>
								<h4>Inventory Options</h4>
							</CardHeader>
							<CardBody>
								<ProductsNav salesArea={salesArea}
									forecastOptions={forecastOptions}
									forecastEnd={forecastEnd}
									growthPercentage={growthPercentage}
									updateProductList={this.updateProductList}
									updateAllProducts={this.updateAllProducts}
									updateGrowthPercentage={this.updateGrowthPercentage}
									pipelines={pipelines}
									pipelineFilters={pipelineFilters}
									updateFilters={this.updateFilters}
									removeFilter={this.removeFilter}/>
							</CardBody>
						</Card>
					</Col>
				</Row>
				<Row>
					<Col>
						{ categories.map(c => {
							return (
								<Card className={'card-table'} key={c}>
									<CardHeader>
										<h4>{c === '' ? 'Uncategorised' : c}</h4>
									</CardHeader>
									<CardBody>
										<ProductsList
											products={productList}
											category={c}
											currentWeek={currentWeek}
											plus1Week={plus1Week}
											plus2Weeks={plus2Weeks}
											plus3Weeks={plus3Weeks}
											forecastCurrent={forecastCurrent}/>
									</CardBody>
								</Card>
							)
						})}
					</Col>
				</Row>
			</div>
		);
	}
}

export default Inventory;
